import gql from 'graphql-tag';

const MUTATION_CHANGE_EMAIL = gql`
  mutation changeEmail($email: EmailAddress!) {
    changeEmail(email: $email) {
      isSuccess
      message
    }
  }
`;

export default MUTATION_CHANGE_EMAIL;
